import { Link } from 'react-router';
import { Icon } from './Icon';
import s from './ViewSidebar.module.css';

export type SidebarView = {
  key: string;
  label: string;
  icon: string;
  count?: number;
  countLabel?: string;
  hot?: boolean;
  separator?: boolean;
  to?: string;
  disabledReason?: string;
};

/** 桌面二级视图栏；手机和 iPad 使用各自的视图入口。 */
export function ViewSidebar({ title, views, active, onPick }: {
  title: string;
  views: SidebarView[];
  active: string;
  onPick: (key: string) => void;
}) {
  return (
    <nav className={s.wrap} aria-label={title}>
      <div className={s.head}>{title}</div>
      <div className={s.body}>
        {views.map((view) => {
          const content = <><Icon name={view.icon} size={14} /><span>{view.label}</span>{(view.countLabel != null || view.count != null) && <i className={`${s.count} ${view.hot ? s.hot : ''} tnum`}>{view.countLabel ?? view.count}</i>}</>;
          const cls = `${s.item} ${view.key === active ? s.on : ''}`;
          return (
            <div key={view.key}>
              {view.separator && <div className={s.sep} />}
              {view.to ? (
                <Link className={cls} to={view.to} aria-current={view.key === active ? 'page' : undefined}>{content}</Link>
              ) : (
                <button type="button" className={cls} onClick={() => onPick(view.key)} disabled={!!view.disabledReason} title={view.disabledReason} aria-pressed={view.key === active}>{content}</button>
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
}
